<!--
    ShowPopular.vue
    Component to show the top 3 tests browsed on the site. Determined by stats pulled from api.js
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
    <div id='popular'>
        <h2>Most Popular Statistics</h2>
        <ul class='cleanList'>
            <li v-for='test in tests' :key='test.id'><router-link :to='{ name:"test", params: { slug: test.slug }}'>{{ test.testName }}</router-link></li>
        </ul>
        </div>
</template>

<script>
export default {
    name: '',
    props: ['tests'],
    data: function() {
        return {
        };
    }
};
</script>

<style scoped>
</style>
